import type { ExtendedUploadItem } from "../../store/uploadStore";

export const LIBRARY_ATTACH_RESUME_FILE_DATA_KEY = "libraryAttachResume";

export type LibraryAttachResumePhase =
  | "started"
  | "vdb_saved"
  | "attach_submitted"
  | "attach_complete"
  | "mesh_imported"
  | "failed";

export type LibraryAttachDeferredPopup = {
  status: "success" | "failed";
  message: string;
  fileName?: string;
};

export type LibraryAttachResumePayload = {
  libraryObjectId: string;
  libraryVseGcsPath: string;
  libraryVsePublicUrl: string;
  displayName: string;
  viewrGcsPath: string;
  targetSpaceIndex: number;
  phase: LibraryAttachResumePhase;
  jobId?: string | null;
  expectedVseIndex?: number | null;
  deferredPopup?: LibraryAttachDeferredPopup | null;
};

export class EditorLibraryAttachDeferredError extends Error {
  constructor(message = "library_attach_editor_deferred") {
    super(message);
    this.name = "EditorLibraryAttachDeferredError";
  }
}

export function isEditorLibraryAttachDeferredError(error: unknown): boolean {
  if (error instanceof EditorLibraryAttachDeferredError) {
    return true;
  }
  return (
    error instanceof Error &&
    error.message === "library_attach_editor_deferred"
  );
}

export function readLibraryAttachResumePayload(
  item: Pick<ExtendedUploadItem, "fileData"> | null | undefined,
): LibraryAttachResumePayload | null {
  const raw = item?.fileData?.[LIBRARY_ATTACH_RESUME_FILE_DATA_KEY];
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const payload = raw as Partial<LibraryAttachResumePayload>;
  if (
    typeof payload.libraryObjectId !== "string" ||
    typeof payload.libraryVseGcsPath !== "string" ||
    typeof payload.libraryVsePublicUrl !== "string" ||
    typeof payload.displayName !== "string" ||
    typeof payload.viewrGcsPath !== "string" ||
    typeof payload.targetSpaceIndex !== "number" ||
    typeof payload.phase !== "string"
  ) {
    return null;
  }
  return payload as LibraryAttachResumePayload;
}

export function isLibraryAttachResumePending(
  payload: LibraryAttachResumePayload | null,
): boolean {
  if (!payload) return false;
  return (
    payload.phase !== "mesh_imported" &&
    payload.phase !== "failed"
  );
}
